import { render } from "./SkillsGrid.vue?vue&type=template&id=7015c581"
import script from "./SkillsGrid.vue?vue&type=script&lang=js"
export * from "./SkillsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__